import { Alert } from '@mui/material';
import { HTMLAttributes, useEffect, useState } from 'react';
import { AssessmentButtons, AssessmentHeader } from '../../shared';

type MedicalInfoIntroProps = {
  patientPreferredName: string;
  isGuardian: boolean;
  titleColor: string;

  onContinue: () => void;
} & Partial<HTMLAttributes<HTMLDivElement>>;

const MedicalInfoIntro = (props: MedicalInfoIntroProps) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { patientPreferredName, isGuardian } = props;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const title = isGuardian
    ? `It looks like we might be a fit. Ready to find a doctor for ${patientPreferredName}?`
    : `It looks like we might be a fit, ${patientPreferredName}. Ready to get matched with a doctor?`;

  const boldedSubtitle = isGuardian
    ? `To find the best match, we have a few more questions, including some about ${patientPreferredName}’s medical history and potential for self-harm.`
    : 'To find the best match, we’ll ask a few more questions about you and your medical history, including your potential for self-harm.';

  return (
    <div>
      <AssessmentHeader
        title={title}
        boldedSubtitle={boldedSubtitle}
        titleColor={props.titleColor}
      />
      <br />
      <Alert severity="info" sx={{ mt: 3 }}>
        Matching only takes about 10 minutes
      </Alert>
      <AssessmentButtons
        primary={{
          children: 'I’m ready',
          type: 'submit',
          onClick: props.onContinue,
        }}
      />
      <img
        src={isMobile ? '/PathwayMobile.svg' : '/PathwayDesktop.svg'}
        style={{
          marginTop: '-20px',
          marginBottom: '-30px',
          width: '100vw',
          position: 'relative',
          left: '50%',
          right: '50%',
          marginLeft: '-50vw',
          marginRight: '-50vw',
          zIndex: -1,
        }}
        alt="Conversation bubble with question mark"
      />
    </div>
  );
};

export default MedicalInfoIntro;
